import React, { useState } from "react";

import { SourceLocation } from "models";

import { Button, Icon, SourcePageViewer, Typography } from "components";

import { DocScanDocumentModal, DocScanDocumentView } from "pages/admin/verifications/components/automations/DocScanDocumentModal";

type DocScanSourceDocumentProps = {
  fileName: string | null;
  fileUrl: string | null;
  sourceLocations: SourceLocation[];
};

export const DocScanSourceDocument = ({ fileName, fileUrl, sourceLocations }: DocScanSourceDocumentProps) => {
  const [isDocumentOpen, setIsDocumentOpen] = useState(false);
  const [documentView, setDocumentView] = useState<DocScanDocumentView>("sourceRows");

  if (!fileUrl) {
    return (
      <Typography variant="paragraph-s" color="grey-600">
        The scanned PDF is no longer stored, so it can&apos;t be shown.
      </Typography>
    );
  }

  const hasSourceRows = sourceLocations.length > 0;

  const openDocument = () => {
    setDocumentView(hasSourceRows ? "sourceRows" : "fullDocument");
    setIsDocumentOpen(true);
  };

  return (
    <div className="doc-scan-source">
      <div className="doc-scan-source-viewer">
        <div className="doc-scan-source-file">
          <Icon iconName="tabler/file-text" size="s" />
          <Typography variant="paragraph-m" bold>
            {fileName ?? "Scanned document"}
          </Typography>
          <Button
            type="secondary"
            size="small"
            className="doc-scan-expand-document"
            iconLeft
            icon={<Icon iconName="tabler/arrows-maximize" size="s" />}
            onClick={openDocument}
          >
            Expand
          </Button>
        </div>
        {hasSourceRows ? (
          <SourcePageViewer pdfUrl={fileUrl} locations={sourceLocations} shouldScrollToRow={false} />
        ) : (
          <Typography variant="paragraph-s" color="grey-600" className="doc-scan-source-note">
            Doc-scan didn&apos;t record where in the PDF it read the values.
          </Typography>
        )}
      </div>
      <DocScanDocumentModal
        fileName={fileName}
        fileUrl={fileUrl}
        sourceLocations={sourceLocations}
        isOpen={isDocumentOpen}
        view={documentView}
        onViewChange={setDocumentView}
        onClose={() => setIsDocumentOpen(false)}
      />
    </div>
  );
};
